/* eslint-disable complexity */
function triggerEdap(eventName, eventData, options) {
    // Until this is production ready, we are going to add Edap events to the debugLog
    // for easy parusal.
    window && window.log ? window.log(`[EDAP] ${eventName} - ${JSON.stringify(eventData)} - ${JSON.stringify(options)}`) : null; // eslint-disable-line

    // The use of 'window' is abstracted to 'this' for the sake fo tests
    // and SSR.  For example, window can be set as the context when calling this function.
    return new Promise((resolve) => {
        // By pushing functions, it allows events to be queued up
        // even if the library hasn't fully loaded.  They get popped off
        // as processed.
        // After the library is loaded, pushed functions automatically
        // get processed.
        this.edap.push((edapInstance) => {
            // trigger returns a sort-of-deferred and not a real es6 Promise, so
            // we need to wrap up its 'then'.

            // Cast numbers or booleans as strings and nulls as '-1' to get closer to the EDAP specs by default
            for (let prop in eventData) {
                if (eventData.hasOwnProperty(prop)) {
                    if (eventData[prop] === null) {
                        eventData[prop] = '-1';
                        continue;
                    }
                    if (typeof eventData[prop] === 'number' || typeof eventData[prop] === 'boolean') {
                        eventData[prop] = String(eventData[prop]);
                    }
                }
            }

            // Doc on what parameters can be:
            // https://github.homeawaycorp.com/edap/edap-integrations#triggering-edap-events
            const triggerDef = edapInstance.trigger(eventName, eventData, options);
            triggerDef.then(() => {
                resolve(true);
            });
        });
    });
}
/* eslint-enable complexity */

export default triggerEdap;
export {triggerEdap};
